/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
import { Img } from "../../../sharedComponents/Images";
// eslint-disable-next-line import/no-cycle
import { Link } from "../../../sharedComponents/Link";
// eslint-disable-next-line import/no-cycle
import { CardLink } from "../HeroCard";
// eslint-disable-next-line import/no-cycle
import { Icon } from "../../Icons";
import * as styles from "./SingleCard.module.scss";

const SingleCard = ({
	image,
	header,
	subheader,
	button,
	link,
	className,
	logo,
	subheader2,
	content,
	collectionVariant,
	theme,
}) => (
	<Card
		className={cx(
			styles.single,
			className,
			collectionVariant === "single-desc" ? styles.singleHasDesc : ""
		)}>
		<Card.Image
			className={styles.singleImage}
			src={!image.srcSet && image.src}
			source={image.srcSet && image}
			alt={image.alt}
			fluid={image.fluid}
		/>
		<Card.BodyContainer
			className={cx(
				styles.singleContainer,
				collectionVariant === "single-vcenter" ? styles.vcenter : "",
				collectionVariant === "single-desc" ? styles.withDesc : ""
			)}>
			{logo && (
				<div className={styles.singleLogo}>
					<Img src={!logo.srcSet && logo.src} source={logo.srcSet && logo} alt={logo.alt} />
				</div>
			)}
			<div className={styles.singleHead}>
				{subheader && (
					<Card.Subheader
						className={cx(
							styles.singleSubhead,
							theme === "wedding" && styles.weddingSubHeadingColor
						)}>
						{subheader}
					</Card.Subheader>
				)}
				<Card.Header
					className={cx(styles.singleHeading, theme === "wedding" && styles.weddingHeadingColor)}>
					{header}
				</Card.Header>
			</div>
			{subheader2 && (
				<div
					className={cx(
						styles.singleDescription,
						theme === "wedding" && styles.weddingSubHeadingColor
					)}>
					{subheader2}
				</div>
			)}
			{content && (
				<div className={styles.singleContent} dangerouslySetInnerHTML={{ __html: content }} />
			)}

			<div className={styles.singleButtons}>
				{button && (
					<div>
						<Card.Button to={button.link}>{button.text}</Card.Button>
					</div>
				)}
				{link?.to && (
					<div>
						<Link to={link.to} className={styles.singleTextLink}>
							{link.text} <Icon name="arrow-right" className={styles.singleTextLinkIcon} />
						</Link>
					</div>
				)}
			</div>
		</Card.BodyContainer>
		{link?.to && <CardLink link={link.to} text={link.text} className={styles.singleLink} />}
	</Card>
);

SingleCard.propTypes = {
	image: PropTypes.shape({
		fluid: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		fixed: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		source: PropTypes.shape({
			src: PropTypes.string,
			srcSet: PropTypes.string,
			sizes: PropTypes.string,
		}),
		alt: PropTypes.string,
		src: PropTypes.string,
		srcSet: PropTypes.string,
	}).isRequired,
	logo: PropTypes.shape({
		fluid: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		fixed: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
		source: PropTypes.shape({
			src: PropTypes.string,
			srcSet: PropTypes.string,
			sizes: PropTypes.string,
		}),
		alt: PropTypes.string,
		src: PropTypes.string,
		srcSet: PropTypes.string,
	}),
	header: PropTypes.string.isRequired,
	subheader: PropTypes.string,
	button: PropTypes.shape({
		icon: PropTypes.string,
		onClick: PropTypes.func,
		text: PropTypes.string,
		link: PropTypes.string,
	}),
	link: PropTypes.shape({
		to: PropTypes.string.isRequired,
		target: PropTypes.string,
		icon: PropTypes.shape({
			svg: PropTypes.shape({
				content: PropTypes.string,
			}),
		}),
		text: PropTypes.string,
	}),
	subheader2: PropTypes.string,
	content: PropTypes.object,
	className: PropTypes.string,
	collectionVariant: PropTypes.string,
	theme: PropTypes.string,
};

SingleCard.defaultProps = {
	subheader: "",
	button: null,
	link: null,
	className: "",
	logo: null,
	collectionVariant: "single",
	subheader2: null,
	content: null,
	theme: null,
};

export default SingleCard;
export { SingleCard };
